import React from "react";
import PropTypes from "prop-types";
import ProfilePage from "./profiles/profile_page";
import MyProfilePage from "./profiles/my_profile_page";

function ProfileComponent(props) {
  const { is_mypage } = props;

  return is_mypage === true ?
    <MyProfilePage {...props} /> : <ProfilePage {...props} />;
}

ProfileComponent.propTypes = {
  is_mypage: PropTypes.bool.isRequired
};

export default ProfileComponent;
